import { networkContactFilter, dateFilter, networkContactSourceFilter, cardTypeFilter } from '@/utils/filters';

export default {
    name: 'ContactDetails',
    props: {
        selectedContact: {
            type: Object,
            default: {}
        },
        show: {
            type: Boolean,
            default: false
        },
        width: {
            type: String,
            default: '800px'
        },
        height: {
            type: String,
            default: 'auto'
        }
    },
    methods: {
        networkContactFilter,
        dateFilter,
        networkContactSourceFilter,
        cardTypeFilter
    },
    computed: {
        questionsAnswers() {
            return this.selectedContact.questionsAnswers
                ? this.selectedContact.questionsAnswers.filter(question => question.answer)
                : [];
        }
    }
};
